// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Metadata } from '../../services/metadata'
import { getDataList } from '../../actions/earnings'
import { updateTargetsList, updateTarget } from '../../actions/targets'
import { StyledContent, StyledGroup } from './style'
import { List, Row, Button, Icon, Input, Col } from 'antd'
const { Item } = List

type Props = {
  targets: string[],
  target: string,
  onUpdateTargets: string[] => void,
  onUpdateTarget: string => void,
  onTabClick: string => void
}

class TargetsList extends Component<Props> {

  state = {
    symbolInput: ''
  }

  componentDidMount() {

    // load user targets
    const { getUser } = new Metadata()
    getUser().then((userRes: Object) => {

      // verify for targets
      const targets = userRes.user_metadata.targets
      if (targets) this.props.onUpdateTargets(targets)
    })
    this.props.loadEarningsData();
  }

  componentDidUpdate() {

    const {
      targets,
      onUpdateTarget
    } = this.props

    if (targets.length === 1) onUpdateTarget(targets[0])
  }

  // --- Remove Item ---
  removeItem = (item: string) => {

    // props
    const { 
      targets, 
      target, 
      onUpdateTargets, 
      onUpdateTarget 
    } = this.props

    // filter target list
    const filtered: string[] = targets.filter((x: string) => x !== item)
    onUpdateTargets(filtered)

    // update state if checked radio button is removed
    if (item === target) onUpdateTarget(filtered[0])
  }

  // --- Remove Item ---
  onAddItem = () => {
    // props
    const {
      targets,
      onUpdateTargets,
      upcomingEarningsTargets
    } = this.props

    const { symbolInput } = this.state;

    // filter target list
    if (this.state.symbolInput) {
      const filtered: string[] = targets.filter((x: string) => x === symbolInput);
      if(!filtered.length) {
        if (upcomingEarningsTargets.find(x=>x.symbol === symbolInput)) {
          onUpdateTargets([...targets, symbolInput]);
          this.setState({
            symbolInput: '',
          })
        }
      }
    }

  }

  onKeyUp = (e) => {
    if (e.which === 13 && this.state.symbolInput) {
      this.onAddItem()
    }
  }

  // change target
  onTargetClick = (value) => {
    this.props.onUpdateTarget(value)
  }

  onChange1 = ({ target: { value } }) => {
    this.setState({
      symbolInput: value,
    })
  }

  render() {

    const {
      targets,
    } = this.props

    const radioTargets = (target: string, index: number): Item => {
      return (
        <Item
          key={index}
          className={target === this.props.target ? 'active-item' : ''}
          actions={[
            <Icon
              key={index}
              type='minus-circle-o'
              onClick={() => this.removeItem(target)} />
          ]}>
          <a onClick={() => this.onTargetClick(target)}>{target}</a>
        </Item>
      )
    }

    return (
      <StyledContent>
        <StyledGroup>
          <Row>
            <Col span={19}>
              <Input type="text" placeholder={'Enter target name'} onKeyUp={this.onKeyUp} value={this.state.symbolInput} size="small" onChange={this.onChange1} /></Col>
            <Col span={5}><Button size="small" type="primary" onClick={this.onAddItem}>Add</Button></Col>
          </Row>
          <List dataSource={targets} renderItem={radioTargets}></List>
        </StyledGroup>
      </StyledContent>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  targets: state.targets.targets || [],
  target: state.targets.target,
  upcomingEarningsTargets: (state.earnings && state.earnings.upcomingEarningsTargets) || []
})

const mapDispatchToProps = (dispatch: Function) => ({
  onUpdateTargets(targetList: string[]) {
    dispatch(updateTargetsList(targetList))
  },
  loadEarningsData() {
    getDataList(dispatch)
  },
  onUpdateTarget(target: string) {
    dispatch(updateTarget(target))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TargetsList)



// WEBPACK FOOTER //
// ./src/components/list-targets/index.js